export default __webpack_public_path__ + "static/media/icon_atras.b15fd886.svg";